import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const createTagCollection = async (formValues) => {
  const formData = new FormData();
  formData.append("CollectionName", formValues.CollectionName);
  formData.append("CollectionTagURL", formValues.CollectionTagURL);
  formData.append("MappedTagIds", formValues.MappedTagIds || "");
  formData.append("Published", formValues.Published.toString());
  formData.append("Featured", formValues.Featured.toString());
  const response = await axiosInstance.post(
    "product/tag-collection",
    formData,
    headers
  );
  return response.data;
};
export const updateTagCollection = async (formValues) => {
  const formData = new FormData();
  formData.append("Id", formValues.Id);
  formData.append("CollectionName", formValues.CollectionName);
  formData.append("CollectionTagURL", formValues.CollectionTagURL);
  formData.append("MappedTagIds", formValues.MappedTagIds || "");
  formData.append("Published", formValues.Published.toString());
  formData.append("Featured", formValues.Featured.toString());

  const response = await axiosInstance.put(
    "product/tag-collection",
    formData,
    headers
  );
  return response.data;
};

export const fetchTagCollections = async () => {
  const response = await axiosInstance.get("product/tag-collection", {
    headers,
  });
  return response.data;
};
export const fetchTagByCollectionByIds = async (ids) => {
  const response = await axiosInstance.post(
    `product/tag-collection/by-collection-ids`,
    ids,
    {
      headers,
    }
  );
  return response.data;
};
export const fetchTagCollectionById = async (id) => {
  const response = await axiosInstance.get(`product/tag-collection/${id}`, {
    headers,
  });
  return response.data;
};

export const publishTagCollection = async (id) => {
  return await await axiosInstance.patch(
    `product/tag-collection/${id}/publish`,
    {
      headers,
    }
  );
};

export const unPublishTagCollection = async (id) => {
  return await await axiosInstance.patch(
    `product/tag-collection/${id}/unpublish`,
    {
      headers,
    }
  );
};

export const markTagCollectionFeatured = async (id) => {
  return await await axiosInstance.patch(
    `product/tag-collection/${id}/featured`,
    {
      headers,
    }
  );
};

export const markTagCollectionUnFeatured = async (id) => {
  return await await axiosInstance.patch(
    `product/tag-collection/${id}/unfeatured`,
    {
      headers,
    }
  );
};

export const deleteTagCollection = async (id) => {
  return await axiosInstance.delete(`product/tag-collection/${id}`, {
    headers,
  });
};
